import './SideNavTray.scss';
import ClickableDiv from 'common/components/clickableDiv/ClickableDiv';
import { MenuItem } from 'common/models/page-config.models';
import { useCompareUrlWithProjectId, useNavigateWithProjectId } from 'common/hooks/route';
import { KWELLO_ICON, KwelloSvgIcon } from 'common/components/icon/KwelloSvgIcon';
import { useParams } from 'react-router-dom';
import { PROJECT_ID_PLACEHOLDER, PROJECT_ID_PREFIX } from 'common/constants';
import { Fragment } from 'react';

interface SideNavTrayProps {
  items: MenuItem[];
  closeSidebar?: () => void;
}

function SideNavTray({ items, closeSidebar }: Readonly<SideNavTrayProps>) {
  const navigate = useNavigateWithProjectId();
  const { compareUrl } = useCompareUrlWithProjectId();
  const { projectId: urlProjectId } = useParams();

  const navigateToRoute = (item: MenuItem) => {
    if (item.children?.length) {
      closeSidebar?.();
      // Navigate to the first child
      navigate(
        item.children[0]?.route?.replace(
          PROJECT_ID_PLACEHOLDER,
          `${PROJECT_ID_PREFIX}${item.projectId ?? (urlProjectId as string)}`
        ) ?? ''
      );
      return;
    }

    if (item.route) {
      closeSidebar?.();
      navigate(
        item.route.replace(
          PROJECT_ID_PLACEHOLDER,
          `${PROJECT_ID_PREFIX}${item.projectId ?? (urlProjectId as string)}`
        )
      );
    }
  };

  return (
    <div className="side-nav-tray">
      {items.map((item) => {
        return (
          <Fragment key={item.id}>
            <ClickableDiv
              className={`side-nav-tray-item ${!item.route && !item.children?.length ? 'sub-heading' : ''} ${item.route || item.children?.length ? 'link' : ''} ${item.route && compareUrl(item.route, { includes: true }) ? 'selected' : ''}`}
              onClick={() => navigateToRoute(item)}
            >
              {item.icon && (
                <div className="side-nav-icon">
                  <KwelloSvgIcon
                    icon={KWELLO_ICON[item.icon.toUpperCase() as keyof typeof KWELLO_ICON]}
                  />
                </div>
              )}
              {item.text}
            </ClickableDiv>
            {item.children
              ?.filter((child) => !child.isTabBar)
              ?.map((child) => (
                <ClickableDiv
                  key={child.id}
                  className={`side-nav-tray-item child ${child.route && compareUrl(child.route, { includes: true }) ? 'selected' : ''} ${child.route ? 'link' : ''}`}
                  onClick={() => navigateToRoute(child)}
                >
                  {item.icon && (
                    <div className="side-nav-icon">
                      <KwelloSvgIcon
                        icon={KWELLO_ICON[item.icon.toUpperCase() as keyof typeof KWELLO_ICON]}
                      />
                    </div>
                  )}
                  {child.text}
                </ClickableDiv>
              ))}
          </Fragment>
        );
      })}
    </div>
  );
}

export default SideNavTray;
